export type MuscleGroupKey =
  | "chest"
  | "back"
  | "shoulders"
  | "biceps"
  | "triceps"
  | "legs"
  | "core"
  | "glutes"
  | "cardio";

export interface CuratedExercise {
  id: string;
  i18nKey: string;
  muscleGroup: MuscleGroupKey;
}

export const EXERCISE_LIBRARY: Record<MuscleGroupKey, CuratedExercise[]> = {
  chest: [
    { id: "chest_supino_reto", i18nKey: "fitness.exercises.chest.supino_reto", muscleGroup: "chest" },
    { id: "chest_supino_inclinado", i18nKey: "fitness.exercises.chest.supino_inclinado", muscleGroup: "chest" },
    { id: "chest_supino_declinado", i18nKey: "fitness.exercises.chest.supino_declinado", muscleGroup: "chest" },
    { id: "chest_crucifixo", i18nKey: "fitness.exercises.chest.crucifixo", muscleGroup: "chest" },
    { id: "chest_peck_deck", i18nKey: "fitness.exercises.chest.peck_deck", muscleGroup: "chest" },
    { id: "chest_crossover", i18nKey: "fitness.exercises.chest.crossover", muscleGroup: "chest" },
    { id: "chest_flexao", i18nKey: "fitness.exercises.chest.flexao", muscleGroup: "chest" },
    { id: "chest_supino_maquina", i18nKey: "fitness.exercises.chest.supino_maquina", muscleGroup: "chest" },
    { id: "chest_pullover", i18nKey: "fitness.exercises.chest.pullover", muscleGroup: "chest" },
    { id: "chest_crucifixo_inclinado", i18nKey: "fitness.exercises.chest.crucifixo_inclinado", muscleGroup: "chest" },
  ],
  back: [
    { id: "back_puxada_frontal", i18nKey: "fitness.exercises.back.puxada_frontal", muscleGroup: "back" },
    // Behind-neck pulldown stays in historical identities, but has no exact demonstration for new selections.
    { id: "back_remada_curvada", i18nKey: "fitness.exercises.back.remada_curvada", muscleGroup: "back" },
    { id: "back_remada_baixa", i18nKey: "fitness.exercises.back.remada_baixa", muscleGroup: "back" },
    { id: "back_remada_unilateral", i18nKey: "fitness.exercises.back.remada_unilateral", muscleGroup: "back" },
    { id: "back_pull_up", i18nKey: "fitness.exercises.back.pull_up", muscleGroup: "back" },
    { id: "back_barra_fixa", i18nKey: "fitness.exercises.back.barra_fixa", muscleGroup: "back" },
    { id: "back_terra", i18nKey: "fitness.exercises.back.terra", muscleGroup: "back" },
    { id: "back_cavalinho", i18nKey: "fitness.exercises.back.cavalinho", muscleGroup: "back" },
    { id: "back_puxada_triangulo", i18nKey: "fitness.exercises.back.puxada_triangulo", muscleGroup: "back" },
  ],
  shoulders: [
    { id: "shoulders_desenvolvimento", i18nKey: "fitness.exercises.shoulders.desenvolvimento", muscleGroup: "shoulders" },
    { id: "shoulders_elevacao_lateral", i18nKey: "fitness.exercises.shoulders.elevacao_lateral", muscleGroup: "shoulders" },
    { id: "shoulders_elevacao_frontal", i18nKey: "fitness.exercises.shoulders.elevacao_frontal", muscleGroup: "shoulders" },
    { id: "shoulders_elevacao_posterior", i18nKey: "fitness.exercises.shoulders.elevacao_posterior", muscleGroup: "shoulders" },
    { id: "shoulders_arnold_press", i18nKey: "fitness.exercises.shoulders.arnold_press", muscleGroup: "shoulders" },
    { id: "shoulders_remada_alta", i18nKey: "fitness.exercises.shoulders.remada_alta", muscleGroup: "shoulders" },
    { id: "shoulders_encolhimento", i18nKey: "fitness.exercises.shoulders.encolhimento", muscleGroup: "shoulders" },
    { id: "shoulders_arnold", i18nKey: "fitness.exercises.shoulders.arnold", muscleGroup: "shoulders" },
    { id: "shoulders_face_pull", i18nKey: "fitness.exercises.shoulders.face_pull", muscleGroup: "shoulders" },
    { id: "shoulders_desenvolvimento_halter", i18nKey: "fitness.exercises.shoulders.desenvolvimento_halter", muscleGroup: "shoulders" },
  ],
  biceps: [
    { id: "biceps_rosca_direta", i18nKey: "fitness.exercises.biceps.rosca_direta", muscleGroup: "biceps" },
    { id: "biceps_rosca_alternada", i18nKey: "fitness.exercises.biceps.rosca_alternada", muscleGroup: "biceps" },
    { id: "biceps_rosca_martelo", i18nKey: "fitness.exercises.biceps.rosca_martelo", muscleGroup: "biceps" },
    { id: "biceps_rosca_scott", i18nKey: "fitness.exercises.biceps.rosca_scott", muscleGroup: "biceps" },
    { id: "biceps_rosca_concentrada", i18nKey: "fitness.exercises.biceps.rosca_concentrada", muscleGroup: "biceps" },
    { id: "biceps_rosca_21", i18nKey: "fitness.exercises.biceps.rosca_21", muscleGroup: "biceps" },
    { id: "biceps_rosca_polia", i18nKey: "fitness.exercises.biceps.rosca_polia", muscleGroup: "biceps" },
    { id: "biceps_rosca_inversa", i18nKey: "fitness.exercises.biceps.rosca_inversa", muscleGroup: "biceps" },
    { id: "biceps_rosca_inclinado", i18nKey: "fitness.exercises.biceps.rosca_inclinado", muscleGroup: "biceps" },
    { id: "biceps_rosca_cabo", i18nKey: "fitness.exercises.biceps.rosca_cabo", muscleGroup: "biceps" },
  ],
  triceps: [
    { id: "triceps_testa", i18nKey: "fitness.exercises.triceps.testa", muscleGroup: "triceps" },
    { id: "triceps_corda", i18nKey: "fitness.exercises.triceps.corda", muscleGroup: "triceps" },
    { id: "triceps_frances", i18nKey: "fitness.exercises.triceps.frances", muscleGroup: "triceps" },
    { id: "triceps_pulley", i18nKey: "fitness.exercises.triceps.pulley", muscleGroup: "triceps" },
    { id: "triceps_mergulho", i18nKey: "fitness.exercises.triceps.mergulho", muscleGroup: "triceps" },
    { id: "triceps_coice", i18nKey: "fitness.exercises.triceps.coice", muscleGroup: "triceps" },
    { id: "triceps_banco", i18nKey: "fitness.exercises.triceps.banco", muscleGroup: "triceps" },
    { id: "triceps_unilateral", i18nKey: "fitness.exercises.triceps.unilateral", muscleGroup: "triceps" },
    { id: "triceps_supino_fechado", i18nKey: "fitness.exercises.triceps.supino_fechado", muscleGroup: "triceps" },
    { id: "triceps_paralelas", i18nKey: "fitness.exercises.triceps.paralelas", muscleGroup: "triceps" },
  ],
  legs: [
    { id: "legs_agachamento", i18nKey: "fitness.exercises.legs.agachamento", muscleGroup: "legs" },
    { id: "legs_leg_press", i18nKey: "fitness.exercises.legs.leg_press", muscleGroup: "legs" },
    { id: "legs_cadeira_extensora", i18nKey: "fitness.exercises.legs.cadeira_extensora", muscleGroup: "legs" },
    { id: "legs_mesa_flexora", i18nKey: "fitness.exercises.legs.mesa_flexora", muscleGroup: "legs" },
    { id: "legs_stiff", i18nKey: "fitness.exercises.legs.stiff", muscleGroup: "legs" },
    { id: "legs_afundo", i18nKey: "fitness.exercises.legs.afundo", muscleGroup: "legs" },
    { id: "legs_bulgaro", i18nKey: "fitness.exercises.legs.bulgaro", muscleGroup: "legs" },
    { id: "legs_hack_squat", i18nKey: "fitness.exercises.legs.hack_squat", muscleGroup: "legs" },
    { id: "legs_panturrilha_em_pe", i18nKey: "fitness.exercises.legs.panturrilha_em_pe", muscleGroup: "legs" },
    { id: "legs_panturrilha_sentado", i18nKey: "fitness.exercises.legs.panturrilha_sentado", muscleGroup: "legs" },
  ],
  core: [
    { id: "core_abdominal", i18nKey: "fitness.exercises.core.abdominal", muscleGroup: "core" },
    { id: "core_prancha", i18nKey: "fitness.exercises.core.prancha", muscleGroup: "core" },
    { id: "core_infra", i18nKey: "fitness.exercises.core.infra", muscleGroup: "core" },
    { id: "core_russian_twist", i18nKey: "fitness.exercises.core.russian_twist", muscleGroup: "core" },
    { id: "core_polia", i18nKey: "fitness.exercises.core.polia", muscleGroup: "core" },
    { id: "core_elevacao_pernas", i18nKey: "fitness.exercises.core.elevacao_pernas", muscleGroup: "core" },
    { id: "core_bicicleta", i18nKey: "fitness.exercises.core.bicicleta", muscleGroup: "core" },
    { id: "core_mountain_climber", i18nKey: "fitness.exercises.core.mountain_climber", muscleGroup: "core" },
    { id: "core_dead_bug", i18nKey: "fitness.exercises.core.dead_bug", muscleGroup: "core" },
    { id: "core_obliquo", i18nKey: "fitness.exercises.core.obliquo", muscleGroup: "core" },
  ],
  glutes: [
    { id: "glutes_hip_thrust", i18nKey: "fitness.exercises.glutes.hip_thrust", muscleGroup: "glutes" },
    { id: "glutes_elevacao_pelvica", i18nKey: "fitness.exercises.glutes.elevacao_pelvica", muscleGroup: "glutes" },
    { id: "glutes_glute_bridge", i18nKey: "fitness.exercises.glutes.glute_bridge", muscleGroup: "glutes" },
    { id: "glutes_sumo", i18nKey: "fitness.exercises.glutes.sumo", muscleGroup: "glutes" },
    { id: "glutes_abducao_maquina", i18nKey: "fitness.exercises.glutes.abducao_maquina", muscleGroup: "glutes" },
    { id: "glutes_cadeira_abdutora", i18nKey: "fitness.exercises.glutes.cadeira_abdutora", muscleGroup: "glutes" },
    { id: "glutes_kickback", i18nKey: "fitness.exercises.glutes.kickback", muscleGroup: "glutes" },
    { id: "glutes_bulgaro_unilateral", i18nKey: "fitness.exercises.glutes.bulgaro_unilateral", muscleGroup: "glutes" },
    { id: "glutes_bom_dia", i18nKey: "fitness.exercises.glutes.bom_dia", muscleGroup: "glutes" },
    { id: "glutes_stiff_unilateral", i18nKey: "fitness.exercises.glutes.stiff_unilateral", muscleGroup: "glutes" },
  ],
  cardio: [
    { id: "cardio_esteira", i18nKey: "fitness.exercises.cardio.esteira", muscleGroup: "cardio" },
    { id: "cardio_bike", i18nKey: "fitness.exercises.cardio.bike", muscleGroup: "cardio" },
    { id: "cardio_eliptico", i18nKey: "fitness.exercises.cardio.eliptico", muscleGroup: "cardio" },
    { id: "cardio_escada", i18nKey: "fitness.exercises.cardio.escada", muscleGroup: "cardio" },
    { id: "cardio_corrida", i18nKey: "fitness.exercises.cardio.corrida", muscleGroup: "cardio" },
    { id: "cardio_caminhada", i18nKey: "fitness.exercises.cardio.caminhada", muscleGroup: "cardio" },
    { id: "cardio_hiit", i18nKey: "fitness.exercises.cardio.hiit", muscleGroup: "cardio" },
    { id: "cardio_burpee", i18nKey: "fitness.exercises.cardio.burpee", muscleGroup: "cardio" },
    { id: "cardio_pular_corda", i18nKey: "fitness.exercises.cardio.pular_corda", muscleGroup: "cardio" },
    { id: "cardio_remo", i18nKey: "fitness.exercises.cardio.remo", muscleGroup: "cardio" },
  ],
};

export const MUSCLE_GROUP_LIST: MuscleGroupKey[] = [
  "chest",
  "back",
  "shoulders",
  "biceps",
  "triceps",
  "legs",
  "core",
  "glutes",
  "cardio",
];
